import React, { useEffect, useState, useRef, useCallback } from "react";

// Home component for displaying and managing guest reviews
import { CiCirclePlus } from "react-icons/ci";
import { MdOutlineMessage } from "react-icons/md";
import { MdOutlineMarkUnreadChatAlt } from "react-icons/md";
import { BellIcon } from "@heroicons/react/24/outline";
import AddGuestModal from "../../AddGuestModal/AddGuestModal";
import UpdateGuestModal from "../../UpdateGuestModal/UpdateGuestModal";
import EditGuestModal from "../../EditGuestModal/EditGuestModal";
import { MagnifyingGlassIcon } from "@heroicons/react/20/solid";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import { toast } from "react-toastify";
import { baseUrl } from "../../../Environments/environment";
import { useAuth } from "../../../Contexts/AuthContext/AuthContext";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import "react-datepicker/dist/react-datepicker.css";
import DatePicker from "react-datepicker";
import "./your-styles.css";
import { CiCalendarDate } from "react-icons/ci";
import Edit from "../../../Assets/edit.svg";
import { useProperty } from "../../../Contexts/PropertyContext/PropertyContext";
import LoadingSpinner from "../../LoadingSpinner/LoadingSpinner";

import checkInI from "../../../Assets/Checkin.svg";
import { useSocket } from "../../../Contexts/SocketContext/SocketContext";
import ChatScreenModal from "../Message/ChatScreenModal/ChatScreenModal";
import AddonRequestModal from "../../AddonRequestModal/AddonRequestModal";
import { apiClient } from "../../../api";
import { useSearchParams } from "react-router-dom";

dayjs.extend(utc);
dayjs.extend(timezone);
const useReactQuerySubscription = (socket, propertyId, selectedDate) => {
  const queryClient = useQueryClient();

  useEffect(() => {
    if (socket) {
      const updateGuests = () => {
        queryClient.invalidateQueries(["guests", propertyId, selectedDate]);
      };

      socket.on("guest:guestStatusUpdate", updateGuests);
      socket.on("guest:guestUpdate", updateGuests);

      return () => {
        socket.off("guest:guestStatusUpdate", updateGuests);
        socket.off("guest:guestUpdate", updateGuests);
      };
    }
  }, [socket, queryClient, propertyId, selectedDate]);
};

const fetchGuests = async (
  propertyId,
  selectedDate,
  searchQuery,
  accessToken,
  todaysDate
) => {
  try {
    const params = {
      ...(searchQuery && { search: searchQuery }),
      todaysDate,
      selectedDate,
    };

    const response = await apiClient.get(`${baseUrl}/guest/${propertyId}`, {
      params: params,
    });
    if (response.ok) {
      const newToken = response.headers.get("Authorization");
      if (newToken) {
        localStorage.setItem("accessToken", newToken.split(" ")[1]); // Save the new token
      }
    }

    return response.data.result.guests;
  } catch (error) {
    toast.error("Failed to fetch guests. Please try again.");
    throw error;
  }
};

export default function Home() {
  const calendarRef = useRef(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isEditGuestModalOpen, setIsEditGuestModalOpen] = useState(false);
  const [isUpdateGuestModalOpen, setIsUpdateGuestModalOpen] = useState(false);
  const [isAddonRequestModalOpen, setIsAddonRequestModalOpen] = useState(false);
  const { propertyChats } = useProperty();

  const [searchParams] = useSearchParams();
  const openModel = searchParams.get("openAddOnsRequest");
  useEffect(() => {
    if (openModel === "true") {
      setIsAddonRequestModalOpen(true);
    }
  }, [openModel]);

  // const [guests, setGuests] = useState([]);
  const [guest, setGuest] = useState();
  const [selectedGuest, setSelectedGuest] = useState(null);
  const { selectedPropertyId } = useProperty();
  const { socket } = useSocket();
  const [searchQuery, setSearchQuery] = useState("");
  const [addOns, setAddOns] = useState([]);

  const { accessToken } = useAuth();
  const propertyId = selectedPropertyId;
  const [selectedDate, setSelectedDate] = useState(
    dayjs().format("YYYY-MM-DD")
  );

  const [isDatePickerOpen, setIsDatePickerOpen] = useState(false);
  const [unCheckedAddonReq, setUncheckedAddonReq] = useState(0);
  const todayDate = dayjs().tz(dayjs.tz.guess()).format("YYYY-MM-DD");
  useEffect(() => {
    const handleNewAddon = (data) => {
      setUncheckedAddonReq((count) => count + data.count);
    };

    socket.on("addOn:newAddon", handleNewAddon);
    return () => {
      socket.off("addOn:newAddon", handleNewAddon);
    };
  }, [socket]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      // Check if click is outside both the dropdown and the trigger button
      if (calendarRef.current && !calendarRef.current.contains(event.target)) {
        setIsDatePickerOpen(false);
      }
    };

    // Only add the event listener if the dropdown is open
    if (isDatePickerOpen) {
      document.addEventListener("click", handleClickOutside);
    }

    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, [isDatePickerOpen]);

  const [addOnLength, setAddOnLength] = useState(0);
  const fetchAddOns = useCallback(async () => {
    try {
      const response = await apiClient.get(
        `${baseUrl}/guest/addons/${propertyId}?requestStatus=Requested`
      );
      console.log(response);
      console.warn(response.data.result.requests);
      if (response.status === 200) {
        const newToken = response.headers.get("Authorization");
        if (newToken) {
          localStorage.setItem("accessToken", newToken.split(" ")[1]); // Save the new token
        }
        console.log("AdddOns -->>>>>>", response.data.result.requests);
        const tempAddons = response.data.result.requests;
        setAddOns(tempAddons);
        setAddOnLength(tempAddons.length);
      }
    } catch (error) {
      console.error("Error fetching requests:", error);
    }
  }, [propertyId]);

  useEffect(() => {
    console.log("USE EFFECT FETCH");
    fetchAddOns();
  }, [fetchAddOns]);

  // useEffect(() => {
  //   console.log("HERE Helllooooo");
  //   console.warn(addOns);
  //   if (addOnLength !== addOns.length) {
  //     setAddOnLength(addOns.length);
  //   }
  // }, [addOns, isAddonRequestModalOpen]);

  const handleDateChange = (date) => {
    if (date) {
      const localDate = dayjs(date).tz(dayjs.tz.guess());
      const formattedDate = localDate.format("YYYY-MM-DD");

      setSelectedDate(formattedDate);
    } else {
      setSelectedDate(null);
    }
    setIsDatePickerOpen(false);
  };

  const getInitials = (firstName, lastName) => {
    return ((firstName?.[0] ?? "") + (lastName?.[0] ?? "")).toUpperCase();
  };

  //  console.log("searach",searchQuery)
  useReactQuerySubscription(socket, propertyId, selectedDate);

  const {
    data: guests = [],
    isLoading,
    error,
  } = useQuery({
    queryKey: ["guests", propertyId, selectedDate, searchQuery], // Include searchQuery
    queryFn: () =>
      fetchGuests(
        propertyId,
        selectedDate,
        searchQuery,
        accessToken,
        todayDate
      ),
    staleTime: 60000,
    cacheTime: 600000,
  });
  const openChatScreen = (guest) => {
    setSelectedGuest(guest);
  };

  const closeChatScreen = () => {
    setSelectedGuest(null);
  };

  const openUpdateGuestModal = () => {
    setIsUpdateGuestModalOpen(true);
  };

  // Function to close the Update Guest modal
  const closeUpdateGuestModal = () => {
    setIsUpdateGuestModalOpen(false);
  };

  // Function to open AddonRequestModal when bell icon is clicked
  const openAddonRequestModal = (e) => {
    e.stopPropagation();
    setIsAddonRequestModalOpen(true);
  };

  if (error) return <p>Error fetching guests.</p>;

  return (
    <>
      {isLoading && <LoadingSpinner />}
      <div className="px-2 sm:px-4 lg:px-6">
        {/* Header Section - Responsive Layout */}
        <div className="flex flex-col space-y-3 sm:space-y-0 sm:flex-row sm:items-center sm:justify-between mt-2 sm:mt-4">
          {/* Date Picker Section */}
          <div className="flex items-center justify-between sm:justify-start">
            <div className="relative inline-block" ref={calendarRef}>
              <h1 className="text-sm sm:text-base font-semibold text-gray-900 flex items-center space-x-2">
                <CiCalendarDate
                  className="text-gray-500 text-2xl sm:text-3xl cursor-pointer hover:text-indigo-600 transition-colors"
                  onClick={() => setIsDatePickerOpen((open) => !open)}
                />
                <span className="whitespace-nowrap">
                  {selectedDate
                    ? dayjs(selectedDate).format("MM/DD")
                    : dayjs().format("MM/DD")}
                </span>
              </h1>
              {isDatePickerOpen && (
                <div className="absolute top-full left-0 mt-2 z-50 bg-white shadow-lg rounded-lg">
                  <DatePicker
                    selected={
                      selectedDate ? dayjs(selectedDate).toDate() : null
                    }
                    onChange={handleDateChange}
                    inline
                    className="border-0 rounded-lg"
                    dateFormat="MM/dd/yyyy"
                  />
                </div>
              )}
            </div>
          </div>

          {/* Search and Button Section */}
          <div className="flex flex-col sm:flex-row items-stretch sm:items-center gap-3 sm:gap-4">
            {/* Search Bar */}
            <div className="flex-1 sm:flex-initial sm:w-64 lg:w-80">
              <label htmlFor="search" className="sr-only">
                Search
              </label>
              <div className="relative text-gray-400 focus-within:text-gray-600">
                <div className="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3">
                  <MagnifyingGlassIcon aria-hidden="true" className="h-4 w-4 sm:h-5 sm:w-5" />
                </div>
                <input
                  id="search"
                  name="search"
                  type="search"
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                  placeholder="Search Request"
                  className="block w-full rounded-xl sm:rounded-2xl border-0 bg-gray-100 py-2 sm:py-1.5 pl-9 sm:pl-10 pr-3 text-sm text-gray-900 placeholder:text-gray-400 focus:ring-2 focus:ring-indigo-500 focus:bg-white transition-colors"
                />
              </div>
            </div>

            {/* Request Review Button */}
            <button
              type="button"
              className="inline-flex items-center justify-center gap-x-1 rounded-md bg-indigo-600 px-3 sm:px-3.5 py-2 sm:py-2.5 text-center text-xs sm:text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600 transition-colors whitespace-nowrap"
              onClick={() => setIsModalOpen(true)}
            >
              <CiCirclePlus className="h-4 w-4 sm:h-5 sm:w-5" aria-hidden="true" />
              <span className="hidden sm:inline">Request Review</span>
              <span className="sm:hidden">Review</span>
            </button>
          </div>
        </div>

        {/* Guests Display - Table for Desktop, Cards for Mobile */}
        <div className="mt-4 sm:mt-6">
          {/* Desktop Table View */}
          <div className="hidden md:block overflow-x-auto">
            <div className="inline-block min-w-full align-middle">
              <div className="overflow-hidden shadow ring-1 ring-black ring-opacity-5 rounded-lg">
                <table className="min-w-full divide-y divide-gray-300">
                  <thead className="bg-[#F9FAFB]">
                    <tr>
                      <th
                        scope="col"
                        className="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900"
                      >
                        Name
                      </th>
                      <th
                        scope="col"
                        className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                      >
                        Email
                      </th>
                      <th
                        scope="col"
                        className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                      >
                        Phone
                      </th>
                      <th
                        scope="col"
                        className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                      >
                        Action
                      </th>
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-gray-200 bg-white">
                    {guests.map((guest) => (
                      <tr key={guest._id} className="hover:bg-gray-50 transition-colors">
                        <td className="whitespace-nowrap py-4 pl-4 pr-3 text-sm">
                          <div className="flex items-center">
                            <div
                              className={`h-10 w-10 flex-shrink-0 flex items-center justify-center rounded-full ${
                                guest.status.preArrivalStatus === "Applied"
                                  ? "bg-green-500"
                                  : "bg-[#6B7280]"
                              } text-white font-medium`}
                            >
                              {guest.status.preArrivalStatus === "Applied" ? (
                                <span className="text-xl">✓</span>
                              ) : (
                                getInitials(guest?.firstName, guest?.lastName)
                              )}
                            </div>
                            <div className="ml-4">
                              <div className="font-medium text-gray-900">
                                {(guest?.firstName ?? "") +
                                  " " +
                                  (guest?.lastName ?? "")}
                              </div>
                            </div>
                          </div>
                        </td>
                        <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                          <div className="max-w-xs truncate" title={guest.email}>
                            {guest.email}
                          </div>
                        </td>
                        <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                          {guest.phoneNumber ? (
                            <>
                              {guest.countryCode} {guest.phoneNumber}
                            </>
                          ) : (
                            <span className="text-red-500">No phone number</span>
                          )}
                        </td>
                        <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                          <div className="flex items-center gap-3">
                            <button
                              className="text-indigo-600 hover:text-indigo-900 transition-colors"
                              onClick={(e) => {
                                e.stopPropagation();
                                openUpdateGuestModal(guest);
                                setGuest(guest);
                              }}
                              aria-label="Edit guest"
                            >
                              <img src={Edit} alt="Edit" className="w-5 h-5" />
                            </button>
                            <button
                              className="relative text-indigo-600 hover:text-indigo-900 transition-colors"
                              onClick={(e) => {
                                e.stopPropagation();
                                openChatScreen(guest);
                              }}
                              aria-label="Open chat"
                            >
                              {propertyChats?.chatLists?.find(
                                (chat) =>
                                  chat.guestId === guest._id &&
                                  chat.unreadMessages > 0
                              ) ? (
                                <MdOutlineMarkUnreadChatAlt
                                  color="#4f46e5"
                                  size={22}
                                />
                              ) : (
                                <MdOutlineMessage color="#4f46e5" size={22} />
                              )}
                              {propertyChats?.chatLists?.find(
                                (chat) =>
                                  chat.guestId === guest._id &&
                                  chat.unreadMessages > 0
                              )?.unreadMessages && (
                                <span className="absolute -top-1 -right-1 bg-red-600 text-white text-xs font-bold px-1.5 py-0.5 rounded-full min-w-[18px] text-center">
                                  {propertyChats?.chatLists?.find(
                                    (chat) =>
                                      chat.guestId === guest._id &&
                                      chat.unreadMessages > 0
                                  ).unreadMessages > 99
                                    ? "99+"
                                    : propertyChats?.chatLists?.find(
                                        (chat) =>
                                          chat.guestId === guest._id &&
                                          chat.unreadMessages > 0
                                      ).unreadMessages}
                                </span>
                              )}
                            </button>
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          {/* Mobile Card View */}
          <div className="md:hidden space-y-3">
            {guests.length === 0 ? (
              <div className="text-center py-8 text-gray-500">
                No guests found
              </div>
            ) : (
              guests.map((guest) => (
                <div
                  key={guest._id}
                  className="bg-white rounded-lg shadow-sm border border-gray-200 p-4 hover:shadow-md transition-shadow cursor-pointer"
                  onClick={() => {
                    openUpdateGuestModal(guest);
                    setGuest(guest);
                  }}
                >
                  <div className="flex items-start justify-between">
                    <div className="flex items-center space-x-3 flex-1 min-w-0">
                      <div
                        className={`h-12 w-12 flex-shrink-0 flex items-center justify-center rounded-full ${
                          guest.status.preArrivalStatus === "Applied"
                            ? "bg-green-500"
                            : "bg-[#6B7280]"
                        } text-white font-medium`}
                      >
                        {guest.status.preArrivalStatus === "Applied" ? (
                          <span className="text-xl">✓</span>
                        ) : (
                          getInitials(guest?.firstName, guest?.lastName)
                        )}
                      </div>
                      <div className="flex-1 min-w-0">
                        <div className="font-semibold text-gray-900 text-sm sm:text-base truncate">
                          {(guest?.firstName ?? "") +
                            " " +
                            (guest?.lastName ?? "")}
                        </div>
                        <div className="mt-1 text-xs sm:text-sm text-gray-500 truncate">
                          {guest.email}
                        </div>
                        <div className="mt-1 text-xs sm:text-sm text-gray-500">
                          {guest.phoneNumber ? (
                            <>
                              {guest.countryCode} {guest.phoneNumber}
                            </>
                          ) : (
                            <span className="text-red-500">No phone number</span>
                          )}
                        </div>
                      </div>
                    </div>
                    <div className="flex items-center gap-2 ml-2 flex-shrink-0">
                      <button
                        className="p-2 text-indigo-600 hover:text-indigo-900 hover:bg-indigo-50 rounded-full transition-colors"
                        onClick={(e) => {
                          e.stopPropagation();
                          openUpdateGuestModal(guest);
                          setGuest(guest);
                        }}
                        aria-label="Edit guest"
                      >
                        <img src={Edit} alt="Edit" className="w-5 h-5" />
                      </button>
                      <button
                        className="relative p-2 text-indigo-600 hover:text-indigo-900 hover:bg-indigo-50 rounded-full transition-colors"
                        onClick={(e) => {
                          e.stopPropagation();
                          openChatScreen(guest);
                        }}
                        aria-label="Open chat"
                      >
                        {propertyChats?.chatLists?.find(
                          (chat) =>
                            chat.guestId === guest._id &&
                            chat.unreadMessages > 0
                        ) ? (
                          <MdOutlineMarkUnreadChatAlt
                            color="#4f46e5"
                            size={22}
                          />
                        ) : (
                          <MdOutlineMessage color="#4f46e5" size={22} />
                        )}
                        {propertyChats?.chatLists?.find(
                          (chat) =>
                            chat.guestId === guest._id &&
                            chat.unreadMessages > 0
                        )?.unreadMessages && (
                          <span className="absolute top-0 right-0 bg-red-600 text-white text-xs font-bold px-1.5 py-0.5 rounded-full min-w-[18px] text-center">
                            {propertyChats?.chatLists?.find(
                              (chat) =>
                                chat.guestId === guest._id &&
                                chat.unreadMessages > 0
                            ).unreadMessages > 99
                              ? "99+"
                              : propertyChats?.chatLists?.find(
                                  (chat) =>
                                    chat.guestId === guest._id &&
                                    chat.unreadMessages > 0
                                ).unreadMessages}
                          </span>
                        )}
                      </button>
                    </div>
                  </div>
                </div>
              ))
            )}
          </div>
        </div>
        {/* Add Guest Modal */}
        <AddGuestModal
          isOpen={isModalOpen}
          onClose={() => setIsModalOpen(false)}
        />

        {/* Render the Update Guest Modal */}
        {isUpdateGuestModalOpen && (
          <UpdateGuestModal
            guest={guest}
            onClose={closeUpdateGuestModal} // Close modal function
          />
        )}

        {guest && (
          <EditGuestModal
            isOpen={isEditGuestModalOpen}
            onClose={() => setIsEditGuestModalOpen(false)}
            guest={guest}
          />
        )}

        {selectedGuest && (
          <ChatScreenModal
            guestId={selectedGuest._id}
            guest={selectedGuest}
            onClose={closeChatScreen}
          />
        )}

        {isAddonRequestModalOpen && (
          <AddonRequestModal
            propertyId={propertyId}
            onClose={(requestedCount) => {
              setAddOnLength(requestedCount);
              setIsAddonRequestModalOpen(false);
              fetchAddOns();
            }}
          />
        )}
      </div>
    </>
  );
}
